import React, { useEffect, useState } from 'react';
import './PorQueElegirnos.css';
import sonrisa from '../assets/images/sonrisa-pacientes.png';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';

const PorQueElegirnos = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section className={`porque-elegirnos${isMobile ? ' mobile-bg' : ''}`}>
      <div className="container">
        <div className="row">
          <div className="col-6 imagen-container">
            <img 
              src={sonrisa} 
              alt="Pacientes sonriendo" 
              className="pacientes-imagen mobile-bg-hide"
              loading="lazy" 
            />
          </div>
          <div className={`${isMobile ? 'col-12' : 'col-6'} contenido`}>
            <h2 className="titulo-principal">RECUPERA TU SONRISA</h2>
            
            <div className="caracteristicas">
              <div className="caracteristica">
                <HashLink to="/profesionales" className="badge-link">
                  <span className="badge">
                    PROFESIONALES DE EXCELENCIA
                  </span>
                </HashLink>
              </div>
              <div className="caracteristica">
                <Link to="/lideres-tecnologicos" className="badge-link">
                  <span className="badge">LÍDERES TECNOLÓGICOS</span>
                </Link>
              </div>
              <div className="caracteristica">
                <Link to="/servicios" className="badge-link">
                  <span className="badge">AMPLIA COBERTURA DE TRATAMIENTOS</span>
                </Link>
              </div>
            </div>

            <div className="descripcion">
              <h3>¿POR QUÉ ELEGIRNOS?</h3>
              <p>
                En CAIMA Centro Avanzado de Implantología Maxilofacial, ubicado en Antofagasta en el norte de Chile, nos comprometemos a brindar la más alta atención en implantes dentales
                ofreciendo tecnología de punta y profesionales especializados en cada área de tratamiento.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PorQueElegirnos; 